"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = void 0;
/* Package Imports */
var query_string_1 = __importDefault(require("query-string"));
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
var react_toastify_1 = require("react-toastify");
var react_router_1 = require("react-router");
/* Blast Imports */
var LoginForm_1 = __importDefault(require("../components/LoginForm"));
var TermsOfServiceModal_1 = require("../components/TermsOfServiceModal");
var actions_1 = require("../state/actions");
var SplitPage_1 = require("@app/components/layout/SplitPage");
var ContainerPanel_1 = require("@app/components/layout/ContainerPanel");
var LegacyBrowserModal_1 = __importDefault(require("@app/features/transfers/components/LegacyBrowserModal"));
var config_1 = require("@app/shared/config");
var constants_1 = require("@app/shared/constants");
var matomo_1 = require("@app/shared/matomo");
var utils_1 = require("@app/shared/utils");
var initialState = {
    blastDomain: '',
    legacyBrowserModalVisible: false,
    savedUserName: '',
    termsOfServiceModalVisible: false
};
/**
 * Login page component
 */
var LoginPage = /** @class */ (function (_super) {
    __extends(LoginPage, _super);
    // Add constructor to set blastDomain in the state before first render
    function LoginPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = initialState;
        /**
         * Returns a boolean determining if a user is internal
         */
        _this.handleValidateUser = function (email) {
            return utils_1.isInternalEmail(email);
        };
        _this.handleLogin = function (username, password) {
            if (password) {
                // Faspex auth
                _this.props.onLogin(username, password, "blast|redirect=" + (_this.state.redirectTo || ''));
            }
            else {
                // SAML Auth
                // Redirect to SAML auth endpoint
                _this.props.onLoginRequest(username);
                window.location.assign("/auth/saml?username=" + username + "&redirectTo=" + encodeURIComponent(_this.state.redirectTo || ''));
            }
        };
        _this.handleAcceptTos = function () {
            _this.props.onAcceptTermsOfService();
        };
        _this.handleCloseAsperaModal = function () {
            _this.setState(__assign(__assign({}, _this.state), { legacyBrowserModalVisible: false }));
        };
        _this.handleCloseTos = function () {
            _this.setState(__assign(__assign({}, _this.state), { authToken: undefined }));
            _this.props.onLogout(false);
            react_toastify_1.toast.warn('You must accept the terms of service to continue');
            _this.props.history.push('/login');
        };
        _this.handleForgotPassword = function (email) {
            if (email) {
                _this.props.onForgotPassword(email);
            }
            else {
                react_toastify_1.toast.dismiss();
                react_toastify_1.toast.error('Please enter your email address before you can request a password reset.');
            }
        };
        var lpState = _this.props.location.state; // Login Page location state
        _this.state = __assign(__assign({}, initialState), { blastDomain: (window && window.location) ? window.location.origin : '', savedUserName: (lpState && lpState.fromRegistration) ? lpState.email : '' });
        return _this;
    }
    LoginPage.getDerivedStateFromProps = function (nextProps, prevState) {
        return __assign(__assign({}, prevState), { savedUserName: prevState.savedUserName === '' ? localStorage.getItem(constants_1.BLAST_REMEMBER_USER_KEY) || '' : prevState.savedUserName, termsOfServiceModalVisible: nextProps.isAuthenticated && !nextProps.termsOfServiceAccepted });
    };
    LoginPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lpState, _a, token, error, redirectTo;
            return __generator(this, function (_b) {
                if (react_device_detect_1.isIE || react_device_detect_1.isLegacyEdge) {
                    this.setState(__assign(__assign({}, this.state), { legacyBrowserModalVisible: true }));
                    new matomo_1.MatomoTracker().trackEvent('Legacy Browser', 'View Modal');
                }
                lpState = this.props.location.state;
                if (lpState && lpState.fromPasswordReset) {
                    react_toastify_1.toast.success('Your password has been reset');
                }
                if (lpState && lpState.fromRegistration) {
                    react_toastify_1.toast.success("New user" + ((lpState && lpState.email) ? ", " + lpState.email + "," : '') + " has been created");
                }
                if (this.props.location.search) {
                    _a = query_string_1.default.parse(this.props.location.search), token = _a.token, error = _a.error, redirectTo = _a.redirectTo;
                    if (error) {
                        if (error === 'User Restricted') {
                            react_toastify_1.toast.error("Login Restriction.\n\nPlease contact Blast Team for assistance (" + config_1.Config.CONTACT_EMAIL + ").", { autoClose: false, toastId: constants_1.LOGIN_ERROR_TOAST_ID });
                        }
                        else {
                            react_toastify_1.toast.error(error, { autoClose: false, toastId: constants_1.LOGIN_ERROR_TOAST_ID });
                        }
                        return [2 /*return*/];
                    }
                    if (token && (react_device_detect_1.isIE || !this.props.isLoggedOut)) {
                        this.setState(__assign(__assign({}, this.state), { authToken: token.toString() }));
                        this.props.onLoginJwt(token.toString());
                    }
                    if (redirectTo) {
                        this.setState(__assign(__assign({}, this.state), { redirectTo: redirectTo.toString() }));
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    LoginPage.prototype.render = function () {
        if (this.props.isAuthenticated && this.props.termsOfServiceAccepted) {
            var redirectPath = this.state.redirectTo || '/';
            return react_1.default.createElement(react_router_1.Redirect, { to: redirectPath });
        }
        if (this.props.loginError) {
            react_toastify_1.toast.dismiss();
            react_toastify_1.toast.error(this.props.loginError, { autoClose: false, toastId: constants_1.LOGIN_ERROR_TOAST_ID });
        }
        var failedAuthentication = !this.props.isAuthenticated &&
            (this.props.isAuthenticating !== true && this.props.isAuthenticating !== undefined);
        if (this.state.authToken && !this.state.termsOfServiceModalVisible && !failedAuthentication) {
            // Don't render the login page if POSTing back from SAML auth
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        // Only use the saved username if not in the authentication process
        var savedUserName = (!this.props.isAuthenticated && !this.props.isAuthenticating) ? this.state.savedUserName : '';
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SplitPage_1.SplitPage, { title: "Login" },
                react_1.default.createElement(ContainerPanel_1.ContainerPanel, { isLoading: this.props.isAuthenticating, title: "Blast is for Official Hasbro Business Only", titleClassName: 'official-title' },
                    react_1.default.createElement(LoginForm_1.default, { fromLogout: this.props.isLoggedOut, onForgotPassword: this.handleForgotPassword, onLogin: this.handleLogin, onValidateUser: this.handleValidateUser, savedUserName: savedUserName }))),
            this.state.legacyBrowserModalVisible &&
                react_1.default.createElement(LegacyBrowserModal_1.default, { isPreLogin: true, onClose: this.handleCloseAsperaModal, onStopAspera: function () { }, onUseBlastLite: function () { } }),
            this.state.termsOfServiceModalVisible &&
                react_1.default.createElement(TermsOfServiceModal_1.TermsOfServiceModal, { onClose: this.handleCloseTos, closeOnEscape: true, onDecline: this.handleCloseTos, onAccept: this.handleAcceptTos })));
    };
    return LoginPage;
}(react_1.Component));
exports.LoginPage = LoginPage;
var mapStateToProps = function (store) {
    return {
        isAuthenticated: store.auth.isAuthenticated,
        isAuthenticating: store.auth.isAuthenticating,
        isLoggedOut: react_device_detect_1.isIE ? true : store.auth.isLogoutInitiated || false,
        loginError: store.auth.loginError,
        termsOfServiceAccepted: store.auth.termsOfServiceAccepted
    };
};
var mapDispatchToProps = {
    onAcceptTermsOfService: actions_1.acceptTermsOfService,
    onForgotPassword: actions_1.navigateToForgotPassword,
    onLogin: actions_1.login,
    onLoginJwt: actions_1.loginWithJwt,
    onLoginRequest: actions_1.loginRequest,
    onLogout: actions_1.logout
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(LoginPage);
